/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { arrayOf, entity, enumeration, subentity } from '@gh/core-data';
import { EDocMapper, EDocType } from '../../e-docs';
import {
  JobEDocLogDto,
  JobEDocOwnerSetDto,
  JobEDocSigningDocumentDto,
  JobEDocSigningRequestDto,
} from './job-e-docs.dto';

export const JobEDocOwnerSetMapper = entity<JobEDocOwnerSetDto>({});

export const JobEDocLogMapper = entity<JobEDocLogDto>({
  log: arrayOf(EDocMapper),
});

export const JobEDocSigningRequestMapper = entity<JobEDocSigningRequestDto>({
  docs: arrayOf(subentity<JobEDocSigningDocumentDto>({
    type: enumeration(EDocType),
  })),
});
